import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import Login from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmail from './pages/VerifyEmail';
import DashboardPage from './pages/Dashboard';
import FormPreview from './pages/WriteLetter';
import ContentPageComponent from './pages/DisplayContentPage';
import RedeemCouponPage from './pages/CouponRedemption';
import ResetPasswordPage from './pages/ResetPassword';
import WelcomePage from './pages/HomePage'



const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen flex flex-col bg-gray-50">
          {/* Navigation with fixed height */}
          <div className="flex-shrink-0">
            <Navigation />
          </div>
          
          {/* Main content area that takes remaining height */}
          <div className="flex-1 h-[calc(100vh-4rem)]"> {/* 4rem matches navbar height */}
            <Routes>
              <Route path="/" element={<WelcomePage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/verify-email/:token" element={<VerifyEmail />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/write" element={<FormPreview />} />
              <Route path="/write/:formId" element={<ContentPageComponent />} />
              <Route path="/redeem-coupon" element={<RedeemCouponPage />} />
              <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            </Routes>
          </div>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default App;